import React from "react";
import Logo from "../../assets/code-zephyr.svg";
import "./Footer.css";
import {
  RiLinkedinLine,
  RiGithubLine,
  RiInstagramLine,
  RiSoundcloudLine,
  RiYoutubeLine,
} from "react-icons/ri";

const Footer = () => (
  <div className="footer section__padding">
    <div className="footer-heading">
      <h1 className="gradient__text">Code, Innovate, Transform, Repeat!</h1>
    </div>

    <div className="footer-btn">Let's Get Started</div>

    <div className="footer-links">
      <div className="footer-links_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="footer-links_div">
        <h4>Resources</h4>
        <p>About Us</p>
        <p>Products</p>
        <p>Services</p>
        <p>Blog</p>
      </div>
      <div className="footer-links_div">
        <h4>Our Policies</h4>
        <p>Terms {"&"} Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="footer-links_div">
        <h4>Get in touch</h4>
        <p>+91 8605640371,</p>
        <p>info@code-zephyr.com</p>
      </div>
    </div>
    <div className="social-links">
      <span className="social-links_icon">
        <RiLinkedinLine />
      </span>
      <span className="social-links_icon">
        <RiGithubLine />
      </span>

      <span className="social-links_icon">
        <RiYoutubeLine />
      </span>

      <span className="social-links_icon">
        <RiInstagramLine />
      </span>
      <span className="social-links_icon">
        <RiSoundcloudLine />
      </span>
    </div>
    <div className="footer-copyright">
      <p>Copyright © 2022 code-zephyr. All rights reserved. </p>
    </div>
  </div>
);

export default Footer;
